import { Bar, BarHeight, BarSpacing } from './Bar';
import { Circle } from './Circle';
import { LoadingBar } from './LoadingBar';
import { Rectangle } from './Rectangle';

export const SkeletonLoaderShapes = {
	Bar,
	BarSpacing,
	BarHeight,
	Rectangle,
	Circle,
	LoadingBar,
};
